import { TransformConvertorBase } from './transform.convertor';
import { ColumnMappingConvertor } from './mapping.convertor';
import { BaseColumnMappingTransformation } from 'app/model/dataflow/base-column-mapping-transformation';
import { ColumnMappingBaseTransformPlainObject } from 'worker/app-workers/shared/plainObjects/columnMappingBase.plainObject';
import { FoldDownTransformation } from 'app/model/dataflow/folddowntransformation';
import { FoldDownPlainObject } from 'worker/app-workers/shared/plainObjects/folddown.plainObject';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from '../../expression.util';
import { AnyDataFlowType, BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { ExpressionBasedColumnPattern } from 'app/model/dataflow/expression-based.column.pattern';
import { BaseSchemaModifierTransformation } from 'app/model/dataflow/base-schema-modifier-transformation';
import { DataFlowSchemaAdapterUtils } from '../../dataflow-schema-adapter-utils';
import { ExpressionColumnPatternPlainObject } from 'worker/app-workers/shared/plainObjects/expressionColumn.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class FoldDownConvertor extends TransformConvertorBase {
    private get foldDownTransform(): FoldDownTransformation {
        return this.transformation as FoldDownTransformation;
    }

    private get foldDownObject(): FoldDownPlainObject {
        return this.transformObject as FoldDownPlainObject;
    }

    private get transformBase(): BaseSchemaModifierTransformation {
        return this.transformation as BaseSchemaModifierTransformation;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        ColumnMappingConvertor.convertFromPlainObject(
            this.foldDownObject as ColumnMappingBaseTransformPlainObject,
            this.foldDownTransform as BaseColumnMappingTransformation,
            this._handledConfigs
        );
        this.foldDownTransform.unrollBy = DataFlowExpressionUtils.unwrapExpressionConfigValue(
            this.foldDownObject.unrollBy,
            this.transformation,
            AnyDataFlowType.TYPE
        );
        this.foldDownTransform.unrollRoot = DataFlowExpressionUtils.unwrapExpressionConfigValue(
            this.foldDownObject.unrollRoot,
            this.transformation,
            AnyDataFlowType.TYPE
        );
        this.foldDownTransform.unrollMultiple = [];
        if (this.foldDownTransform.unrollBy.expression) {
            this.foldDownTransform.unrollMultiple.push(this.foldDownTransform.unrollBy);
        }
        this.foldDownObject.unrollMultiple?.forEach((expression) => {
            this.foldDownTransform.unrollMultiple.push(
                DataFlowExpressionUtils.unwrapExpressionConfigValue(
                    expression,
                    this.transformation,
                    AnyDataFlowType.TYPE
                )
            );
        });
        this.foldDownObject.columns?.forEach((column) => {
            const derivedColumnPattern = new ExpressionColumnPatternPlainObject();
            derivedColumnPattern.condition = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                column.templateCondition
            );
            derivedColumnPattern.hierarchyLevelExpression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                column.hierarchyLevelExpression
            );
            derivedColumnPattern.unEscapedRegexString = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                column.unEscapedRegexString
            );
            DataFlowSchemaAdapterUtils.addColumnPatternToTransform(this.transformBase, derivedColumnPattern);
            this.foldDownTransform.columnPatterns.forEach((pattern) => {
                const columnPattern = pattern as ExpressionBasedColumnPattern;
                columnPattern.deepHierarchy = column.deepHierarchy;
                columnPattern.columns.forEach((col) => (col.dataFlowExpression.returnType = new BooleanDataFlowType()));
            });
        });
        super.postConvert();
        return this.transformation;
    }
}
